import * as React from 'react';

import { connect } from 'redux-zero/react';

import actions, { IActions } from '../actions';
import Configurator from '../components/Configurator';

import Budget from '../components/Budget';
import { IStore } from '../types/index';

const mapToProps = (props: IStore) => ({
  ...props
});

const Page: React.SFC<IStore & IActions> = props => (
  <div>
    <header id="bigboy-header">
      <div className="container clearfix">
        <img src="/LandingsNew/M4300-96X-configurator/imagesnetgear-logo.png" className="logo" alt="logo" />
        <h1>
          <span className="switch-model">M4300-96X</span> Switch Configuration Tool
        </h1>
      </div>
    </header>
    <main className="main">
      <div className="container">
        <div className="row">
          <div className="section bigboy-configuration col-md-12 hidePDF">
            <h3 className="section-title">Configure your modular switch</h3>
            <p className="section-subtitle">
              You may begin a new M4300-96X configuration below.
              <span className="d-none d-md-inline">
                {' '}
                Click or unclick ports and features you need. Alternatively, click the "+" sign on the Front View to add
                port cards.{' '}
              </span>{' '}
              <br />
              Finally, download your bill of materials as a PDF or XLS file.
            </p>
          </div>
          <div className="section bigboy-intro-pdf col-md-12">
            <h3 className="section-title">
              M4300-96X: <span>Up to 96-port 10G or 24-port 40G</span>
            </h3>
            <h5>Modular. Granular. Unique.</h5>
            <a href="https://netgear.com/m4300">M4300 Product Page</a>
            <a href="https://netgear.com/96x-config">M4300-96X Configurator</a>
          </div>
        </div>
        <Configurator
          {...{
            routerData: props.routerData,
            slotsItems: props.slotsItems,
            budget: props.budget,
            availablePower: props.availablePower,
            updateSlotsWithNumber: props.updateSlotsWithNumber,
            updatePowerSupply: props.updatePowerSupply,
            updateProSupport: props.updateProSupport,
            setRedundantSupply: props.setRedundantSupply,
            setSlotRouterItemFront: props.setSlotRouterItemFront
          }}
        />
        {/* End Row switch */}
      </div>
      <div className="table-details">
        <div className="container">
          <div className="row">
            <div className="section col-md-12">
              <Budget
                {...{
                  routerData: props.routerData,
                  slotsItems: props.slotsItems,
                  budget: props.budget,
                  changeRegion: props.changeRegion
                }}
              />
            </div>
            {/* End Row table*/}
          </div>
        </div>
      </div>
    </main>
  </div>
);
export default connect(mapToProps, actions)(Page);



// WEBPACK FOOTER //
// ./src/containers/Page.tsx